module.exports = __webpack_public_path__ + "static/img/temp2.6fb76911.png";